import { Card, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerCard from "../../../common/components/BannerCard";
import { asDate } from "../../../common/constants/Helpers";
import { LookupRequest } from "../../../models/lookup-request";
import { buildSummaryRequest, civilRequest } from "../../../state/connect-api";
import { useCivilCaseStatusMutation, useGetCaseStatusMutation } from "../../../state/globalApi";
import { setCivilMaster, updateCaseMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CaseStatus = ({ ...props }) => {
  const { activeCaseNumber } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCaseStatus, result] = useGetCaseStatusMutation();
  const [getCivilCaseStatus, civilResult] = useCivilCaseStatusMutation();
  const configurations = getConfigs([
    "ctStatusRemarks",
    "ctTRCRStatusTxt",
    "ctCVLStatusTxt"
  ]);

  const [messageVisible, setMessageVisible] = useState<boolean>(true);

  useEffect(() => {
    if (props.civilTab) {
      const lookupRequest: LookupRequest = civilRequest(activeCaseNumber);
      const fetch = async () => {
        const status = await getCivilCaseStatus(lookupRequest).unwrap();
        dispatch(setCivilMaster({ status: status }));
        setMessageVisible(!!configurations.ctCVLStatusTxt);

      };
      fetch();
    } else {
      const lookupRequest = buildSummaryRequest(activeCaseNumber);
      setMessageVisible(!!configurations.ctTRCRStatusTxt);
      const fetch = async () => {
        const status = await getCaseStatus(lookupRequest).unwrap();
        dispatch(updateCaseMaster({ status: status }));
      };

      fetch();
    }
  }, [activeCaseNumber, dispatch, getCaseStatus]);

  const columns = [
    { key: "status",title: "Status", dataIndex: "STATUS"},
    { key: "nextDate", title: "Next Date", dataIndex: "NEXT_DATE", ...asDate },
    { key: "nextTime", title: "Next Time", dataIndex: "NEXT_TIME" },
    (configurations.ctStatusRemarks === "Y" || (configurations.ctStatusRemarks === "A" && localStorage.getItem("LOGINTYPE") === "A")) &&
    { key: "remark", title: "Remarks", dataIndex: "REMARKS" }
  ].filter(Boolean);

  const civilColumns = [
    { key: "status", title: "Status", dataIndex: "Description"},
    { key: "nextDate", title: "Next Date", dataIndex: "CaseStatusItemNextDate" },
    { key: "nextTime", title: "Next Time", dataIndex: "CaseStatusItemNextTime" },
    (configurations.cvStatusRemarks === "Y" || (configurations.cvStatusRemarks === "A" && localStorage.getItem("LOGINTYPE") === "A")) &&
    { key: "remark", title: "Remarks", dataIndex: "CaseStatusItemComments" }
  ].filter(Boolean);;

  return (
    <Row gutter={[16, 16]}>
      {configurations.ctTRCRStatusTxt && messageVisible && (
        <Col xl={23} lg={23} md={23} sm={23} xs={23}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: props.civilTab ? configurations.ctCVLStatusTxt : configurations.ctTRCRStatusTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <BannerCard title="Status">
          <Table size="small" dataSource={props.civilTab ? civilResult?.data?.LIST : result?.data?.LIST} columns={props.civilTab ? civilColumns : columns} scroll={{ x: 720 }} />
        </BannerCard>
      </Col>
    </Row>
  );
};

export default CaseStatus;
